import {ParamCodeExporter} from '../Param';
import {ButtonParam} from '../../../../../../@polygonjs/polygonjs/src/engine/params/Button';

export class ParamButtonCodeExporter extends ParamCodeExporter<ButtonParam> {
	override add_main() {}
	override HTMLSnippet() {
		const id = this._HTMLId(this._param);
		const buttonInput = `<button id='${id}'>${id}</button>`;
		return buttonInput;
	}
	override JSSnippet() {
		const id = this._HTMLId(this._param);
		return `document.getElementById('${id}').addEventListener('click', function(event){
	scene.node('${this._param.node.path()}').p.${this._param.name()}.pressButton();
})`;
	}
}
